module.exports = __webpack_public_path__ + "static/media/back-rg.c7a6df38.svg";